import axios from 'axios';
import { message } from 'antd';

const reportedErrors = new WeakSet();
const isObject = value => value !== null && typeof value === 'object';

export function requestErrorText(error, fallback = '请求失败，请稍后重试。') {
    if (error?.response?.data?.reason === 'EMAIL_NOT_VERIFIED') return '你的邮箱未验证，请验证邮箱后重新登录。';
    if (error?.code === 'storage/unauthorized') return '没有上传或访问此文件的权限。';
    if (error?.code === 'storage/unauthenticated') return '登录状态已失效，请重新登录。';
    if (error?.code === 'storage/retry-limit-exceeded') return '文件传输超时，请稍后重试。';
    if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') return '请求超时，请稍后重试。';
    const status = Number(error?.response?.status);
    if (status >= 500) return '服务暂时不可用，请稍后重试。';
    if (status === 401) return '登录状态已失效，请重新登录。';
    if (status === 403) return '没有执行此操作的权限。';
    if (status === 429) return '请求过于频繁，请稍后重试。';
    if (status === 408) return '请求超时，请稍后重试。';
    if (axios.isAxiosError(error) && !error.response) return '网络连接失败，请检查网络后重试。';
    const detail = error?.response?.data?.message;
    if (typeof detail === 'string' && detail.trim()) return detail;
    return ({ 400: '请求参数有误，请检查后重试。', 404: '请求的资源不存在或已被删除。', 405: '当前操作暂不支持。', 409: '数据已更新，请刷新后重试。', 422: '提交的数据不符合要求，请检查后重试。' })[status] || fallback;
}

export function showRequestError(error, fallback) {
    if (axios.isCancel(error) || error?.code === 'storage/canceled' || error?.reported || (isObject(error) && reportedErrors.has(error))) return;
    if (isObject(error)) reportedErrors.add(error);
    message.error({ key: 'request-error', content: requestErrorText(error, fallback), duration: 3 });
}

// Last-resort production feedback only. Page-level rejection handlers remain
// required: a native event listener cannot reliably preempt the dev overlay.
export function installRequestFeedback() {
    message.config({ top: 24, duration: 3, maxCount: 1 });
    const onUnhandledRequest = event => {
        const error = event.reason;
        if (!axios.isAxiosError(error) && !axios.isCancel(error) && !error?.reported) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showRequestError(error);
    };
    window.addEventListener('unhandledrejection', onUnhandledRequest, true);
    return () => window.removeEventListener('unhandledrejection', onUnhandledRequest, true);
}
